import React from 'react';

import CustomNumeral from '../../../shared/customNumeral.component';
import { NumeralTypes } from '../../../shared/numeral.component';

import ToggleCaret from '../toggleCaret.component';
import { negativePercentage } from '../utils/numeral.utils';
import EffectiveTaxRateDetailLink from '../effectiveTaxRateDetailLink.component';

import { GroupRendererPropTypes } from './proptypes';
import GroupingColumns from '../GroupingColumns.component';

const AccountGroupRenderer = ({
  rowData,
  ibtAmount,
  isOpen,
  toggle,
  suppressHidingDecimalPlacesForPercentage,
  tagName,
  isLastInBranch,
  hideGroupingColumns,
}) => (
  <div className="row child-row expandable account-row account" onClick={toggle}>
    <div className="etr-icon-wrapper stick-left" />
    <div className="col-6 description stick-left" title={rowData.descr}>
      { !isLastInBranch && (
        <ToggleCaret isOpen={isOpen} />
      )}
      <span className="row-desc-text">{rowData.descr}</span>
    </div>
    <div className="col-2 text-right">
      <EffectiveTaxRateDetailLink tagName={tagName} account={rowData.descr} ibtAmount={ibtAmount}>
        <CustomNumeral type={NumeralTypes.DECIMAL}>{rowData.amount}</CustomNumeral>
      </EffectiveTaxRateDetailLink>
    </div>
    <div className="col-2 text-right">
      <CustomNumeral
        additionalClassNames={negativePercentage}
        type={NumeralTypes.PERCENT_4}
        suppressHidingDecimalPlaces={suppressHidingDecimalPlacesForPercentage}
      >
        {(rowData.amount / ibtAmount)}
      </CustomNumeral>
    </div>
    <GroupingColumns
      hideGroupingColumns={hideGroupingColumns}
      columnsData={rowData.columnsData}
    />
  </div>
);

AccountGroupRenderer.propTypes = GroupRendererPropTypes;

export default AccountGroupRenderer;
